import { useMemo } from 'react';

export const SEARCH_FLEX = 3;
export const GENERAL_FLEX = 2;
export const CLEAR_FILTER_FLEX = 0.5;

export const getGridItemProps = (flex) => ({
	size: {
		xs: 12,
		md: 'grow',
	},
	sx: {
		minWidth: 0,
		height: '100%',
		display: 'flex',
		alignItems: 'flex-end',
		flexBasis: {
			md: 0,
		},
		flexGrow: {
			md: flex,
		},
	},
});

export const useGridItemProps = () => {
	const searchGridProps = useMemo(() => getGridItemProps(SEARCH_FLEX), []);
	const generalGridProps = useMemo(() => getGridItemProps(GENERAL_FLEX), []);

	const clearFilterGridProps = useMemo(() => {
		const initSx = {
			alignItems: 'end',
			height: '100%',
			display: 'flex',
			justifyContent: 'end',
		};
		const gridItemProps = getGridItemProps(CLEAR_FILTER_FLEX);
		return {
			...gridItemProps,
			sx: {
				...gridItemProps.sx,
				...initSx,
			},
		};
	}, []);

	return { searchGridProps, generalGridProps, clearFilterGridProps };
};
